import React, { useState } from 'react'
import { connect } from 'react-redux'
import { ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap'
import classNames from 'classnames'

import { InfoButton } from 'components/buttons'
// @ts-ignore
import { getFirstNames } from 'registry/reducers'
// @ts-ignore
import { Modal } from 'components/modal'
// @ts-ignore
import ShippingAddressForm from 'registry/forms/shipping-address-form'
// @ts-ignore
import { saveGiftGiverAddress } from 'registry/actions'
// @ts-ignore
import { MultiStepWizard } from 'components/presentation'
// @ts-ignore
import { ConfirmAddressForm } from 'shared/address-forms/confirm-address-form'
// @ts-ignore
import css from './ThankYouAddressModal.scss'
import { GiftGiverInfoValues } from '../../../../cart/components/reserve-purchased-gift-modal/reserve-purchased-gift-modal'
import {
  AddressSuggestion,
  FieldErrors,
  getHandleSubmit,
  getHandleSubmitFail,
  getWrappedSuggestionForm,
} from './ThankYouAddress.utils'

interface ThankYouAddressModalProps {
  registryFirstNames: string
  afterSubmit: () => void
  onHide: () => void
  giftGiverInfo: GiftGiverInfoValues
  dispatch: (action: () => any) => Promise<any>
}

export const ThankYouAddressModal = (props: ThankYouAddressModalProps) => {
  const { registryFirstNames, afterSubmit, onHide, giftGiverInfo, dispatch } =
    props
  const [fieldErrors, setFieldErrors] = useState<FieldErrors | undefined>()
  const [activeStep, setActiveStep] = useState<number>(1)
  const [recommendedAddress, setRecommendedAddress] = useState<
    AddressSuggestion | undefined
  >()
  const [enteredAddress, setEnteredAddress] = useState<AddressSuggestion>({
    name: giftGiverInfo.name || '',
  })

  const handleSubmit = getHandleSubmit(
    dispatch,
    saveGiftGiverAddress,
    giftGiverInfo
  )
  const handleSubmitFail = getHandleSubmitFail(
    setRecommendedAddress,
    setEnteredAddress,
    setFieldErrors,
    setActiveStep
  )
  const handleAfterSubmit = () => (afterSubmit ? afterSubmit() : onHide())
  const WrappedSuggestionForm = getWrappedSuggestionForm(
    setActiveStep,
    handleAfterSubmit,
    handleSubmit,
    fieldErrors,
    enteredAddress,
    recommendedAddress
  )

  return (
    <Modal show size="large" onHide={onHide}>
      <ModalHeader className="with-title" closeButton onHide={onHide}>
        <ModalTitle className={classNames('h3', css.ModalTitle)}>
          Where can {registryFirstNames || 'the family'} send a thank you note?
          💌
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <MultiStepWizard activeStep={activeStep}>
          {/* step 1 */}
          <ShippingAddressForm
            address={enteredAddress}
            onSave={handleSubmit}
            onSubmitSuccess={handleAfterSubmit}
            onSubmitFail={handleSubmitFail}
            showCancelButton
            onCancel={handleAfterSubmit}
            cancelText="Skip"
            excludedFields={['phone']}
            ctaSectionClassName={css.ctaSection}
            secondaryButtonComponent={InfoButton}
          />
          {/* step 2 */}
          {recommendedAddress ? (
            <WrappedSuggestionForm />
          ) : (
            <ConfirmAddressForm
              onConfirm={() => {
                handleSubmit({
                  ...enteredAddress,
                  userConfirmed: true,
                }).then(() => handleAfterSubmit())
              }}
              onEdit={() => setActiveStep(1)}
              enteredAddress={enteredAddress as any}
              fieldErrors={fieldErrors}
            />
          )}
        </MultiStepWizard>
      </ModalBody>
    </Modal>
  )
}

const mapStateToProps = (state: any) => ({
  registryFirstNames: getFirstNames(state),
})

export default connect(mapStateToProps, null)(ThankYouAddressModal)
